import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ResultValueBlock.styled';
import WrapResultValue from '../../atoms/WrapResultValue/WrapResultValue';
import TextLabel, { TextLabelTypes } from '../../atoms/TextLabel/TextLabel';

const ResultValueBlock = (props) => {
  return (
    <WrapResultValue>
      <TextLabel type={TextLabelTypes.GREY_BOLD}>{props.title}</TextLabel>
      <Styled.ResultValue>{props.value}</Styled.ResultValue>
    </WrapResultValue>
  );
};

ResultValueBlock.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default ResultValueBlock;
